




























import { Element, Audit } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'

@Component({
  components: {
    HistoricalChangesList: () => import('@/components/modals/HistoricalChangesList.vue')
  }
})
export default class ElementHistoricalModal extends Vue {
  @Prop({ required: true }) element: Element

  audits: Audit[] = []
  loading = false

  @Watch('element.id', { immediate: true })
  onElementChanged() {
    this.loadHistorical()
  }

  hideModal() {
    this.$bvModal.hide('elementHistoricalModal')
  }

  private async loadHistorical() {
    this.audits = []
    if (this.element == null || this.element.id == null) {
      return
    }
    try {
      this.loading = true
      const response = await ApiClient.searchAudit(this.element.id, 'Element')
      this.audits = response
    } catch (e) {
      console.error(e)
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('feedback.error_title_generic'),
        variant: 'danger',
        message: this.$t('feedback.error_message_generic')
      })
    } finally {
      this.loading = false
    }
  }
}
